import { sessionStorageGet, sessionStorageSet } from '../session-storage';

export default function adminAccordion() {
  return {
    visibleSections: {},

    init() {
      this.visibleSections = sessionStorageGet('adminAccordion.visibleSections') || {};
    },

    toggleSection(id) {
      this.visibleSections[id] = !this.visibleSections[id];
      sessionStorageSet('adminAccordion.visibleSections', this.visibleSections);
    },

    sectionVisible(id) {
      return this.visibleSections[id];
    },
  };
}
